import axios from "../helpers/axios";

class BlockService {
    public blockFan = (fanId: string) => {
        const url = `/block-fans/${fanId}`;
        return new Promise<any>((resolve, reject) => {
            axios
                .post(url)
                .then((response) => {
                    if (response?.data) resolve(response.data);
                    else reject("Something went wrong");
                })
                .catch((error) => {
                    if (error?.response?.data?.message) reject(error.response.data.message);
                    else reject("Something went wrong.");
                });
        });
    };

    public unblockFan = (fanId: string) => {
        const url = `/block-fans/unblock/${fanId}`;
        return new Promise<any>((resolve, reject) => {
            axios
                .post(url)
                .then((response) => {
                    if (response?.data) resolve(response.data);
                    else reject("Something went wrong");
                })
                .catch((error) => {
                    if (error?.response?.data?.message) reject(error.response.data.message);
                    else reject("Something went wrong.");
                });
        });
    };

    public getBlockedFansList = () => {
        const url = `/block-fans`;
        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then((response) => {
                    if (response?.data) resolve(response.data);
                    else reject("Something went wrong");
                })
                .catch((error) => {
                    if (error?.response?.data?.message) reject(error.response.data.message);
                    else reject("Something went wrong.");
                });
        });
    };
}

export const blockService = new BlockService();
